import { render, staticRenderFns } from "./RejectApplicantConfirmationDialog.vue?vue&type=template&id=58d4c43e&"
import script from "./RejectApplicantConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./RejectApplicantConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
